import axios from 'axios';
import { API_URL } from './config';

const apiClient = axios.create({
    baseURL: API_URL,
    // headers: {
    //     "Content-Type": "application/json",
    // },
});

apiClient.interceptors.request.use(
    config => {
        const token = localStorage.getItem('@accessToken');
        if (token) {
            config.headers['Authorization'] = 'Bearer ' + token;
            config.headers['x-access-token'] = token;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Session expirée (jeton JWT invalide/expiré) ou compte désactivé en cours de
// session : on nettoie la session locale et on renvoie vers la page de
// connexion au lieu de laisser les écrans échouer silencieusement.
let sessionRedirecting = false;
apiClient.interceptors.response.use(
    response => response,
    error => {
        const status = error?.response?.status;
        const message = error?.response?.data?.message;
        const isLoginCall = /\/login(\b|\/)/.test(error?.config?.url || '');
        const sessionLost =
            (status === 401 && message === 'Unauthorized!') ||
            (status === 403 && message === 'accountDisabled');

        if (sessionLost && !isLoginCall && !sessionRedirecting) {
            sessionRedirecting = true;
            localStorage.removeItem('@accessToken');
            localStorage.removeItem('@accessUser');
            localStorage.removeItem('@permissions');
            window.location.assign('/login');
        }
        return Promise.reject(error);
    }
);

export default apiClient;